import React from 'react';
import './Contact.css';

export default function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="contact-bar">
        <span className="contact-label">// contact</span>
      </div>
      <div className="contact-body">
        <div className="contact-cmd">
          <span className="contact-prompt">$</span>
          <span className="contact-text"> curl -X POST shahd.me/contact \</span>
          <div className="contact-arg">-d '&#123;"subject": "let's build something"&#125;'</div>
        </div>
        <div className="contact-links">
          <a href="mailto:me@shahd.me" className="c-link main">
            <span>me@shahd.me</span>
            <span className="c-arrow">↗</span>
          </a>
          <a
            href="https://linkedin.com/in/shahdabubaker"
            target="_blank"
            rel="noopener noreferrer"
            className="c-link"
          >
            <span>LinkedIn</span>
            <span className="c-arrow">↗</span>
          </a>
          <a
            href="https://wa.me/962780000270"
            target="_blank"
            rel="noopener noreferrer"
            className="c-link"
          >
            <span>WhatsApp</span>
            <span className="c-arrow">↗</span>
          </a>
        </div>
      </div>
    </section>
  );
}
